import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { TransactionListItem } from "@common/schemas/transaction.schema";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { TransactionDescriptionColumnContent } from "../ListItem/TransactionDescriptionColumnContent";
import styles from "./DescriptionCell.module.scss";

export const DescriptionCell = memo(
    ({ row }: CellContext<ViewTableFeatures, TransactionListItem, any>) => (
        <ViewTableCell>
            <TransactionDescriptionColumnContent
                transaction={row.original}
                className={styles.descriptionContent}
            />
        </ViewTableCell>
    ),
);
DescriptionCell.displayName = "DescriptionCell";
